import moment from "moment";
import React, { useEffect, useState } from "react";
import DatePicker from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
const format = "DD-MM-YYYY";

const MultiSelectDate = ({ setConvertedDays, minDate, prevDates, isEdit }) => {
  const [dates, setDates] = useState(
    prevDates?.length > 0
      ? prevDates.map((dateString) => new Date(dateString?.leave_date))
      : []
  );

  useEffect(() => {
    if (dates?.length > 0) {
      const formattedDates = dates.map((timestamp) => {
        const date = new Date(timestamp);
        if (!isNaN(date.getTime())) {
          const formattedDate = moment(date).tz("Asia/Kolkata").format("DD-MM-YYYY");
          return formattedDate;
        }
        return "";
      });
      setConvertedDays(formattedDates);
    } else {
      setConvertedDays([]);
    }
  }, [dates]);

  // console.log("prevDates=> ", prevDates);

  return (
    <div className="multi-select-date">
      <DatePicker
        value={dates}
        onChange={setDates}
        format={format}
        multiple
        sort
        plugins={[<DatePanel />]}
        minDate={minDate}
        disabled={
          isEdit && prevDates?.length > 0
            ? prevDates.some((leave) => leave?.approval_status === 1)
            : false
        }
        placeholder="Select Dates"
      />
    </div>
  );
};

export default MultiSelectDate;
